import { Component, DestroyRef, inject, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Alert } from 'src/app/shared/models/Alert';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { AlertService } from 'src/app/shared/services/alert.service';
import { PaginationService } from 'src/app/shared/services/pagination.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { saveAs } from 'file-saver';
import { UserRequestDTO } from 'src/app/shared/models/UserRequestDto';
import { Subject, takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipDirective } from '../../../directives/tooltip.directive';
import { SearchPipe } from '../../../pipes/search.pipe';
@Component({
    selector: 'app-list-customer-users',
    templateUrl: './list-customer-users.component.html',
    styleUrl: './list-customer-users.component.css',
    imports: [
        CommonModule,
        FormsModule,
        TooltipDirective,
        SearchPipe
    ]
})
export class ListCustomerUsersComponent {

  @Input() customerDataInput: any;
  customers: any[] = [];
  filteredCustomers: any[] = [];
  textoBusqueda: string = '';
  camposBusqueda: string[] = [
    'userId',
    'userNames',
    'userMail',
    'userPhone',
    'numberPlans',
    'numberDevices',
  ];
  isFilteredByStatus: boolean = false;
  originalCustomers: any[] = [];
  selectedCustomer: any;
  idModule: number = 4;
  alert: Alert = {} as Alert;
  userRequestDTO: UserRequestDTO = {
    userId: undefined,
  };

  constructor(
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService,
    public paginationService: PaginationService
  ) { }

  ngOnInit() {


  }

  ngOnChanges() {
    this.userRequestDTO.userId = this.customerDataInput.userId;

    this.customerService.getListUsersOfCustomer(this.userRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListCustomers(Data);
        } else {
          this.HandleGetListCustomersError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }

  get pages(): number[] {
    return this.paginationService.pages;
  }

  changePage(page: number) {
    this.paginationService.changePage(page);
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  previousPage() {
    this.paginationService.previousPage();
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  nextPage() {
    this.paginationService.nextPage(this.filteredCustomers.length);
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  getRange(): string {
    return this.paginationService.getRange(this.filteredCustomers.length);
  }

  HandleGetListCustomersError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  HandleGetListCustomers(customerList: UserDTO[]) {
    // Guarda la lista de clientes original
    this.customers = customerList;
    this.originalCustomers = this.customers.slice();
    this.customers = this.originalCustomers.filter(
      (user) => user.userStatus === 0 || user.userStatus === 1
    );
    // Llama al servicio para filtrar y paginar los datos
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );

    // Reinicia la paginación a la primera página
    this.paginationService.currentPage = 1;
  }

  onSearchChange(): void {
    this.paginationService.currentPage = 1;
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  filterByStatus(status: number) {
    this.customers = this.originalCustomers.slice();
    if (!this.isFilteredByStatus) {
      this.originalCustomers = this.customers.slice();
      this.isFilteredByStatus = true;
    }

    this.customers = this.originalCustomers.filter(
      (customer) => customer.userStatus === status
    );

    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  clearFilter() {
    this.isFilteredByStatus = false;
    this.customers = this.originalCustomers.slice();
    this.customers = this.customers.filter(
      (user) => user.userStatus === 0 || user.userStatus === 1
    );
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  setSelectedCustomer(customer: any) {
    this.selectedCustomer = customer;
  }

  setArchivedCustomer(customer: any) {
    this.selectedCustomer = customer;
    //this.selectedCustomer.userStatus = 2;
    this.selectedCustomer['@userStatus'] = this.selectedCustomer.userStatus !== 2 ? 1 : 2;
  }

  toggleStatus(event: any, customer: any) {
    customer.userStatus = event.target.checked ? 1 : 0;
    const indice = this.originalCustomers.findIndex(
      (cust) => cust.userId === customer.userId
    );
    if (indice !== -1) {
      this.originalCustomers[indice].userStatus = customer.userStatus;
    }
  }

  openConfirmationModal(customer: any) {
    this.selectedCustomer = customer;
  }

  updateUserStatus(confirmed: boolean) {
        
    if (confirmed) {
      if (typeof this.selectedCustomer['@userStatus'] === 'number') this.selectedCustomer.userStatus = this.selectedCustomer['@userStatus'];
      this.customerService
        .updateCustomerStatus(this.selectedCustomer)
        .subscribe(
          ({ StatusCode, Message, Data }) => {
            if (Data != null) {
              this.HandleUpdateCustomerStatus(Data);
            } else {
              this.HandleUpdateCustomerStatusError(StatusCode);
            }
          },
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000
            };
            this.alertService.updateAlertState(
              this.alert
            );
          }
        );
    } else {
      location.reload();
    }
  }

  HandleUpdateCustomerStatusError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  async HandleUpdateCustomerStatus(customer: boolean) {
    this.alert = {
      alertMessage: 'Customer status updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    location.reload();
  }

  navigateToUpdateUser(customer: any) {
    this.router.navigate(['/customers/user-update'], {
      relativeTo: this.route,
      state: { customerData: customer },
    });
  }

  // navigateToCustomerUsers(customer: any) {
  //   this.router.navigate(['/customers/customer-users'], {
  //     relativeTo: this.route,
  //     state: { customerData: customer },
  //   });
  // }

  goBack() {
    window.location.href = '/home';
  }

  // navigateToCustomerView(customer: any) {
  //   this.router.navigate(['/customers/view-customer', customer.userId]);
  // }

  // exportCustomerListToExcel() {
  //   this.customerService.exportCustomersListToExcel().subscribe(
  //     (response: ResponseDataFile) => {
  //       if (response) {
  //         this.handleDownload(response);
  //       } else {
  //         this.handleGetListCustomersError();
  //       }
  //     },
  //     (error) => {
  //       console.error('Error al exportar el archivo Excel:', error);
  //     }
  //   );
  // }

  // private handleDownload(data: ResponseDataFile) {
  //   const byteCharacters = atob(data.Data.fileContents);
  //   const byteNumbers = new Array(byteCharacters.length);
  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }
  //   const byteArray = new Uint8Array(byteNumbers);
  //   const blob = new Blob([byteArray], { type: data.Data.contentType });
  //   saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

  // 	this.alert = {
  //     alertMessage: 'File generated successfully',
  //     alertType: 'alert alert-success',
  //     alertCenter: false,
  //     alerTitle: '',
  //     duration: 3000
  //   };
  //   localStorage.setItem('AlertObject', JSON.stringify(this.alert));
  //   this.alertService.updateAlertState(
  //     this.alert
  //   );
  // }

  // private handleGetListCustomersError() {
  //   this.alert = {
  //     alertMessage: 'Unexpected error. Please try again later.',
  //     alertType: 'alert alert-danger',
  //     alertCenter: false,
  //     alerTitle: '',
  //     duration: 3000
  //   };
  //   this.alertService.updateAlertState(
  //     this.alert
  //   );
  // }
}
